import { ref, watch, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04a60af6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filterCombinedComponent"
};
const _hoisted_2 = {
  class: "blockBody"
};
const _hoisted_3 = {
  class: "optBlock"
};
const _hoisted_4 = {
  key: 3,
  class: "error-msg"
};
import { debounce, cloneDeep } from 'lodash';
import { useRoute } from 'vue-router';
import useGetSelect from '@/hooks/useGetSelect';
import { awaitWrap, filterOption, getNode, OK } from '@/common';
import { message } from 'ant-design-vue';
import { translator } from '@/api/goodsSetting';
export default /*#__PURE__*/_defineComponent({
  __name: 'MultiComponents1',
  props: {
    disabled3: {
      type: Boolean,
      default: false
    },
    nameRule: {
      type: Object,
      default: () => {
        return {
          placeholder: '商品名称, 最多30字符',
          maxLength: 30
        };
      }
    },
    desRule: {
      type: Object,
      default: () => {
        return {
          placeholder: '商品描述, 最多45字符',
          maxLength: 45
        };
      }
    },
    mode: {
      type: Number,
      default: 0 // 0 且 1 或
    },
    filterItems: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultLang: {
      type: String,
      default: 'en-US'
    },
    channel: {
      type: String,
      default: 'google'
    },
    showLastLangInfo: {
      type: Boolean,
      default: false
    }
  },
  emits: ['setProdId', 'getLastLange'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    // import { CloseOutlined } from '@ant-design/icons-vue'
    const {
      langOptions,
      langValToItem,
      getLangOptions
    } = useGetSelect();
    const route = useRoute();
    const langDisabled = value => {
      if (props.disabled3) {
        // 如果 filterItems.lang 存在 value 不可编辑
        return originData.value.some(item => item.lang === value);
      }
      return false;
    };
    const items = ref([]); // 定义筛选栏展示合集
    const loading = ref(false);
    const calcSelectOptions = () => {
      if (!items.value.length || !langOptions.value.length) return;
      const chosenArray = items.value.map(item => item.lang); // 所有语言下拉框选中项组成的集合
      const returnArray = []; // 空的语言下拉框内容，等待重组
      langOptions.value.forEach(item => {
        if (!chosenArray.includes(item.value)) {
          // 没有选中的语言，推入空的下拉框内
          returnArray.push(langValToItem[item.value]);
        }
      });
      items.value = items.value.map((item, ind) => {
        var _cloneDeep;
        // 如果没有key，则手动添加
        if (!item.key) {
          item.key = new Date().getTime() + '-' + ind;
        }
        // 已经选中的语言，推入到下拉框头部
        item.langOptions = (_cloneDeep = cloneDeep(returnArray)) === null || _cloneDeep === void 0 ? void 0 : _cloneDeep.filter(item => item);
        if (item.lang && langValToItem[item.lang]) {
          item.langOptions.unshift(langValToItem[item.lang]);
        }
        return item;
      });
    }; // 计算筛选栏可选项,筛出无人选择的项以及添加自己选择的项
    const changeName = async (val, ind) => {
      items.value[ind].prodName = items.value[ind].prodName.trim();
      items.value[ind].prodName = items.value[ind].prodName.replace(/\|/g, '');
      items.value[ind].prodName = items.value[ind].prodName.replace(/｜/g, '');
      val = val.trim();
      if (ind !== 0) return;
      if (['en-US', 'en_US'].includes(items.value[0].lang)) {
        return emits('setProdId', val);
      }
      try {
        const [err, res] = await awaitWrap(translator({
          sourceLang: items.value[0].lang,
          sourceText: val,
          targetLang: ['en_Us']
        }));
        if (err) {}
        if (res && res.code === OK) {
          var _res$data;
          emits('setProdId', (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.translateList[0].translatedResult);
        }
      } catch (e) {}
    }; // 变更商品名，第一组元素的值需要传出去用于拼接内购id
    const changeProdDescription = (val, ind) => {
      items.value[ind].prodDescription = items.value[ind].prodDescription.trim();
      items.value[ind].prodDescription = items.value[ind].prodDescription.replace(/\|/g, '');
      items.value[ind].prodDescription = items.value[ind].prodDescription.replace(/｜/g, '');
    }; // 过滤前后空格
    const pushItem = debounce(() => {
      items.value.push({
        key: new Date().getTime(),
        lang: '',
        langOptions: cloneDeep(langOptions.value),
        prodDescription: '',
        prodName: ''
      });
      calcSelectOptions();
    }, 40); // 添加筛选指标信息
    const deleteItem = i => {
      items.value.splice(i, 1);
      calcSelectOptions();
    }; // 删除条件栏
    const translateLang = async () => {
      let targetLang = items.value.slice(1).filter(item => !!item.lang).map(item => item.lang);
      if (!targetLang.length) return message.error('请选择要翻译的语言');
      if (!items.value[0].prodName || !items.value[0].prodDescription) return message.error('请先填写默认语言商品名称和描述');
      loading.value = true;
      getTransLate();
      await getTransLate(false);
      loading.value = false;
    }; // 翻译
    const getTransLate = async (isName = true) => {
      let targetLang = items.value.slice(1).filter(item => !!item.lang).map(item => item.lang);
      try {
        const [err, res] = await awaitWrap(translator({
          sourceLang: items.value[0].lang,
          sourceText: isName ? items.value[0].prodName : items.value[0].prodDescription,
          targetLang: targetLang
        }));
        if (err) {}
        if (res && res.code === OK) {
          var _res$data2;
          (_res$data2 = res.data) === null || _res$data2 === void 0 || _res$data2.translateList.forEach(item => {
            items.value.map(i => {
              if (i.lang === item.lang) {
                if (isName) {
                  i.prodName = item.translatedResult;
                } else {
                  i.prodDescription = item.translatedResult;
                }
              }
            });
          });
        }
      } catch (e) {}
    };
    const getLastLange = () => {
      emits('getLastLange');
    };
    const originData = ref([]);
    watch(() => props.filterItems, n => {
      if (n) {
        items.value = n;
        // if (originData.value.length === 0) {
        //   originData.value = cloneDeep(n) as any
        // }
        if (items.value[0] && !items.value[0].key) {
          // 判断是否经过前端加key和添加语言选项
          calcSelectOptions();
        }
      }
    }, {
      deep: true,
      immediate: true
    });
    watch(() => props.defaultLang, n => {
      if (n) {
        items.value[0].lang = n;
        calcSelectOptions();
      }
    }, {
      immediate: true
    }); // 监听默认语言变化
    onMounted(async () => {
      try {
        var _route$query;
        await getLangOptions({
          prodChnl: ((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.prodChnl) || ''
        });
        calcSelectOptions();
      } catch (error) {}
    });
    expose({
      originData
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, ind) => {
        return _openBlock(), _createElementBlock("div", {
          key: item.key,
          class: "item"
        }, [item.langOptions ? (_openBlock(), _createBlock(_component_a_select, {
          key: 0,
          class: "selecter",
          disabled: props.disabled || langDisabled(item.lang),
          value: item.lang,
          "onUpdate:value": $event => item.lang = $event,
          options: item.langOptions,
          placholder: "请选择语言",
          onChange: calcSelectOptions,
          getPopupContainer: _unref(getNode),
          "show-search": "",
          "filter-option": _unref(filterOption)
        }, null, 8, ["disabled", "value", "onUpdate:value", "options", "getPopupContainer", "filter-option"])) : _createCommentVNode("", true), _createVNode(_component_a_input, {
          class: "selecter ml8",
          disabled: props.disabled,
          value: item.prodName,
          "onUpdate:value": $event => item.prodName = $event,
          valueModifiers: {
            trim: true
          },
          placeholder: props.nameRule.placeholder,
          onBlur: $event => changeName(item.prodName, ind)
        }, null, 8, ["disabled", "value", "onUpdate:value", "placeholder", "onBlur"]), _createVNode(_component_a_input, {
          class: "selecter bigInput ml8",
          disabled: props.disabled,
          value: item.prodDescription,
          "onUpdate:value": $event => item.prodDescription = $event,
          valueModifiers: {
            trim: true
          },
          onBlur: $event => changeProdDescription(item.prodDescription, ind),
          placeholder: props.desRule.placeholder
        }, null, 8, ["disabled", "value", "onUpdate:value", "onBlur", "placeholder"]), _withDirectives(_createElementVNode("div", _hoisted_3, [_withDirectives(_createVNode(_component_SvgIcon, {
          "icon-class": "circle_add",
          class: "optIcon ml8",
          onClick: _unref(pushItem)
        }, null, 8, ["onClick"]), [[_vShow, items.value.length < _unref(langOptions).length]]), _withDirectives(_createVNode(_component_SvgIcon, {
          "icon-class": "circle_decrease",
          class: "optIcon ml8",
          onClick: $event => deleteItem(ind)
        }, null, 8, ["onClick"]), [[_vShow, items.value.length > 1 && !langDisabled(item.lang)]])], 512), [[_vShow, ind === items.value.length - 1 && !props.disabled]]), items.value.length === 1 && __props.showLastLangInfo ? (_openBlock(), _createBlock(_component_a_button, {
          key: 1,
          disabled: props.disabled,
          ghost: "",
          type: "primary",
          class: "robot-btn",
          onClick: getLastLange
        }, {
          default: _withCtx(() => [_createTextVNode(" 复用历史语言 ")]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true), items.value.length > 1 && ind === 0 ? (_openBlock(), _createBlock(_component_a_button, {
          key: 2,
          loading: loading.value,
          disabled: props.disabled,
          ghost: "",
          type: "primary",
          class: "robot-btn",
          onClick: translateLang
        }, {
          icon: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "robot",
            "class-name": "robot-icon"
          })]),
          default: _withCtx(() => [_createTextVNode(" 智能翻译 ")]),
          _: 1
        }, 8, ["loading", "disabled"])) : _createCommentVNode("", true), item.error ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.error), 1)) : _createCommentVNode("", true)]);
      }), 128))])]);
    };
  }
});